export const numberFormat = (value, localeFormatter) => {
  return new Intl.NumberFormat(localeFormatter).format(value);
};
